const openAsBlob = (bites, headers) => {
  let fileName = '';
  const disposition = headers['content-disposition'];
  const contentType = headers['content-type'] || 'application/pdf';
  if (disposition && disposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }
  }

  const blob = new Blob([bites], { type: contentType });
  const linkSource = window.URL.createObjectURL(blob);

  window.open(linkSource, '_blank');
};

export default Object.freeze({ openAsBlob });
